import React, { useEffect, useState } from 'react';
import { SearchContentSectionProps } from '../ContentSection';
import {
  Container,
  Flex,
  Grid,
  Group,
  Image,
  Stack,
  Text
} from '@mantine/core';
import LoaderContentItem from '../../../section/ContentSection/LoaderContentItem';
import IllustrationState from '../../IllustrationState';
import EventItem from '../../../section/EventSection/EventItem';
import { useQuery } from '@tanstack/react-query';
import { getEventList } from '../../../../services/event';
import useLocalStorage from '../../../../hooks/useUserData';
import NoData from '../../../../assets/icon/illustrations_no-document.svg';
import Button from '../../../elements/Button';

const EventSection = ({ isDetail, courseName }) => {
  const [userData, setUserData] = useLocalStorage('persist:root', null);
  const profile = JSON.parse(userData?.auth);
  const [contentList, setContentList] = useState([]);

  const fetchedEventList = useQuery({
    queryKey: [`getEventList`, courseName],
    queryFn: () =>
      getEventList({
        name: courseName,
        page: 1,
        pageSize: 1000,
        jobBand: profile?.userData?.jobBand
      }),
    enabled: !!courseName
  });

  const { data: eventList, isLoading } = fetchedEventList;

  useEffect(() => {
    if (eventList?.data?.length > 0) {
      setContentList(eventList?.data);
    } else {
      setContentList([]);
    }
  }, [eventList?.data]);

  return (
    <Container size={'xl'} w={'100%'} px={0}>
      <Flex direction={'column'} mb={6}>
        <Group align="center" justify="space-between">
          <Stack gap={0}>
            <Text fz={20} fw={700}>
              Course Events
            </Text>
            <Text fz={14} fw={500} c={'gray'}>
              {contentList.length} Results
            </Text>
          </Stack>
          {!isDetail && contentList.length > 4 && (
            <Button
              variant="link"
              linkTo={`/search/detail?type=006&search=${courseName}`}
            >
              View All
            </Button>
          )}
        </Group>
        <Grid mt={12} justify={'flex-start'}>
          {isLoading && (
            <>
              {[...Array(4)].map((_, i) => (
                <Grid.Col span={4} key={i}>
                  <LoaderContentItem />
                </Grid.Col>
              ))}
            </>
          )}

          {!isLoading && contentList.length === 0 && (
            <Grid.Col span={12}>
              <IllustrationState
                isIlustration={false}
                Illustration={<Image src={NoData} w={'50%'} />}
                description="No result found"
              />{' '}
            </Grid.Col>
          )}

          {!isLoading &&
            contentList.length > 0 &&
            contentList.map((content, i) => {
              return <EventItem {...content} key={i} />;
            })}
        </Grid>
      </Flex>
    </Container>
  );
};

export default EventSection;
